<template>
  <section>
    <el-button
      type="primary"
      v-if="uploadType !== 2 && !disabled"
      v-bind="btnOptions"
      :disabled="disabled"
      @click="selectFile"
      >{{ btnOptions.text || "选择文件" }}
    </el-button>
    <el-button
      v-if="uploadType !== 1 && !disabled"
      v-bind="btnFolderOptions"
      :disabled="disabled"
      @click="selectFolder"
    >
      >{{ btnFolderOptions.text || "选择文件夹" }}
    </el-button>
    <div
      class="el-upload__tip"
      v-show="showTip && (fileSize || (accept !== '*' && accept))"
    >
      只能上传{{ fileSize ? `不超过${fileSize}${sizeUnit}的` : ""
      }}{{
        accept === "*" || !accept
          ? "文件"
          : fileTypeList
              .filter((item) => accept.includes(item.value))
              .map((item) => item.label)
              .toString()
      }}
    </div>
    <template v-if="fileList.length">
      <transition-group
        class="el-upload-list el-upload-list--text"
        tag="ul"
        name="el-list"
      >
        <li
          v-for="(file, index) in fileList"
          :key="file.id"
          :class="{ 'mobile-is-success': isMobile }"
          class="el-upload-list__item is-success"
        >
          <template v-if="isMobile">
            <a class="el-upload-list__item-name" @click="handleClick(file)">
              <i class="el-icon-document"></i>{{ file.name }}
            </a>
            <label
              v-if="!disabled"
              class="el-upload-list__item-status-label"
              @click="handleRemove(file, index)"
            >
              <i class="el-icon-upload-danger el-icon-circle-close"></i>
            </label>
          </template>
          <template v-else>
            <a class="el-upload-list__item-name" @click="handleClick(file)">
              <i class="el-icon-document"></i>{{ file.name }}
            </a>
            <label class="el-upload-list__item-status-label">
              <i class="el-icon-upload-success el-icon-circle-check"></i>
            </label>
            <i
              class="el-icon-close"
              v-if="!disabled"
              @click="handleRemove(file, index)"
            />
          </template>
        </li>
      </transition-group>
    </template>
    <el-input
      v-else-if="!fileList.length && disabled"
      value="暂无文件"
      disabled
    />

    <div id="global-uploader">
      <!-- 上传 -->
      <uploader
        ref="uploader"
        :auto-start="false"
        class="uploader-app"
        :file-status-text="fileStatusText"
        :options="handleOptions"
        @file-complete="fileComplete"
        @file-error="onFileError"
        @file-progress="onFileProgress"
        @file-success="onFileSuccess"
        @files-added="onFilesAdded"
      >
        <uploader-unsupport />
        <uploader-btn
          id="rock-uploader-partial-folder-btn"
          ref="uploadFolderBtn"
          :directory="true"
          :single="true"
        >
          选择文件夹
        </uploader-btn>
        <uploader-btn
          id="rock-uploader-partial-btn"
          ref="uploadBtn"
          :single="limit === 1"
          :attrs="attrs"
        >
          选择文件
        </uploader-btn>
        <uploader-list v-show="panelShow">
          <div slot-scope="scope" class="file-panel">
            <div class="file-title">
              <div class="title">上传列表</div>
              <div class="middle" />
              <div class="operate">
                <span class="warning-about-empty-folder"
                  >空文件夹不会被上传</span
                >
                <el-button
                  title="收起"
                  type="text"
                  icon="el-icon-minus"
                  @click="close"
                />
                <el-button
                  title="关闭"
                  type="text"
                  icon="el-icon-close"
                  @click="closeCache"
                />
              </div>
            </div>

            <div class="file-list">
              <uploader-files ref="files" :file="scope.fileList" :list="true" />
              <div v-if="!scope.fileList.length" class="no-file">
                <el-image
                  :src="require('@/assets/images/data_empty.png')"
                  style="width: 300px; height: 200px"
                />
              </div>
            </div>
          </div>
        </uploader-list>
      </uploader>
    </div>
  </section>
</template>

<script>
import Uploader from "vue-simple-uploader";
import SparkMD5 from "spark-md5";
import { baseURL, tokenName } from "@/config/net.config";
import { checkUpload, downloadPartialFile, mergeUpload } from "@/api/publicApi";
import { mapGetters } from "vuex";
// 引入vant
import { Toast, Dialog } from "vant";
import "vant/lib/toast/style";
import "vant/lib/dialog/style";

const units = {
  KB: 1024,
  MB: 1024 * 1024,
  GB: 1024 * 1024 * 1024,
};

export default {
  name: "RockUploader",
  install(Vue) {
    Vue.component("RockUploader", this);
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showTip: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 1,
    },
    btnOptions: {
      type: Object,
      default: () => ({}),
    },
    btnFolderOptions: {
      type: Object,
      default: () => ({}),
    },
    accept: {
      type: String,
      default: "*",
    },
    fileSize: {
      default: 2,
    },
    sizeUnit: {
      type: String,
      default: "MB",
    },
    chunkSizeUnit: {
      type: String,
      default: "MB",
    },
    uploadType: {
      type: Number,
      default: 1, // 0：全部，1：上传文件，2：上传文件夹
    },
    uploaderOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Uploader: Uploader.Uploader,
    // UploaderDrop: Uploader.UploaderDrop,
    UploaderBtn: Uploader.UploaderBtn,
    UploaderUnsupport: Uploader.UploaderUnsupport,
    UploaderList: Uploader.UploaderList,
    UploaderFiles: Uploader.UploaderFiles,
    // UploaderFile: Uploader.UploaderFile,
  },
  data() {
    return {
      hideSuccess: false,
      options: {
        target: baseURL + "/dms/file/upload/chunk",
        chunkSize: 5 * 1024 * 1024, // 每个上传的数据块的大小（以字节为单位）默认: 1*1024*1024
        fileParameterName: "file", // 用于文件块的多部分 POST 参数的名称
        maxChunkRetries: 0, // 上传失败前块的最大重试次数。有效值是任何正整数并且undefined没有限制。(默认: 0)
        simultaneousUploads: 10, // 同时上传的数量（默认值：3）
        allowDuplicateUploads: false, // 传文件后，允许重新上传相同的文件。默认情况下，如果一个文件已经上传，它将被跳过，除非该文件从现有的 Uploader 对象中删除。(默认: false)
        testChunks: true, //是否开启服务器分片校验
        initialPaused: false, // 初始暂停状态，默认false
        // 服务器分片校验函数，秒传及断点续传基础
        checkChunkUploadedByResponse: function (chunk, message) {
          let objMessage = JSON.parse(message);
          if (objMessage.code === 2001) {
            // 1 秒传
            return true;
          } else {
            // 没传过
            return (objMessage.data || []).indexOf(chunk.offset + 1) >= 0;
          }
        },
        headers: { token: localStorage.getItem(tokenName) },
        query: {
          key: "4",
          parent: "0",
          type: 4,
        },
      },
      attrs: {
        accept: "*",
      },
      index: 0,
      fileList: this.value,
      panelShow: false, //选择文件后，展示上传panel
      loading: undefined, // 上传中加载

      fileTypeList: [
        { label: "图片", value: "image/*" },
        { label: "视频", value: "video/*" },
        { label: "音频", value: "audio/*" },
        { label: "EXCEL", value: ".xls,.xlsx" },
        { label: "WORD", value: ".doc,.docx" },
        { label: "PDF", value: ".pdf" },
        { label: "TXT", value: ".txt" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      screenWidth: "screenWidth",
    }),

    isMobile() {
      return this.screenWidth <= 425;
    },

    //Uploader实例
    uploader() {
      return this.$refs.uploader.uploader;
    },
    handleOptions() {
      const options = { ...this.options, ...this.uploaderOptions };
      if (this.uploaderOptions.chunkSize)
        options.chunkSize =
          this.uploaderOptions.chunkSize * units[this.chunkSizeUnit];
      return options;
    },
  },
  watch: {
    value: {
      handler(val) {
        this.fileList = val;
      },
      immediate: true,
    },
    accept(val) {
      this.attrs.accept = val;
    },
  },
  methods: {
    selectFile() {
      this.$refs.uploadBtn.$el.click();
    },
    selectFolder() {
      this.$refs.uploadFolderBtn.$el.click();
    },
    // 用作多个文件的校验。如果说返回了 false，那么这个文件就会被忽略，不会添加到文件上传列表中。
    onFilesAdded(files) {
      // 限制单次最大上传数量
      const limitation = 300;
      if (files.length > limitation) {
        if (this.isMobile) {
          Dialog.alert({
            title: "提示",
            message: `文件过多，单次最多可上传${limitation}个文件！`,
          }).then(() => {
            this.clearFile(files);
            return false;
          });
        } else {
          this.$alert(`文件过多，单次最多可上传${limitation}个文件！`, "提示", {
            confirmButtonText: "确定",
            callback: () => {
              this.clearFile(files);
            },
          });
        }
        return false;
      }
      // 限制最大上传数量
      if (
        (this.fileList.length === this.limit || files.length > this.limit) &&
        this.limit
      ) {
        if (this.isMobile) {
          Dialog.alert({
            title: "提示",
            message: `当前限制最多可以上传${this.limit}个文件！`,
          }).then(() => {
            this.clearFile(files);
            return false;
          });
        } else {
          this.$alert(`当前限制最多可以上传${this.limit}个文件！`, "提示", {
            confirmButtonText: "确定",
            callback: () => {
              this.clearFile(files);
            },
          });
        }
        return false;
      }

      // 限制文件类型和单个文件最大大小
      const unitNum = units[this.sizeUnit];
      let isRightSize = true;
      let isAccept = true;
      for (let file of files) {
        if (this.accept !== "*" && this.accept) {
          // isAccept = new RegExp(this.accept).test(file.fileType);
          const strRegex =
            "\\.(" +
            this.accept
              .replace(/\.|>|\/|\?]/g, "")
              .split(",")
              .join("|") +
            ")$";
          isAccept = new RegExp(strRegex).test(file.relativePath);
          if (!isAccept) {
            if (this.isMobile) {
              Dialog.alert({
                title: "提示",
                message: `应该选择${this.accept}类型的文件！`,
              }).then(() => {
                this.clearFile(files);
                return false;
              });
            } else {
              this.$alert(`应该选择${this.accept}类型的文件！`, "提示", {
                confirmButtonText: "确定",
                callback: () => {
                  this.clearFile(files);
                },
              });
            }
            return false;
          }
        }

        if (!this.fileSize) return true;
        isRightSize = file.size / unitNum < this.fileSize;
        if (!isRightSize) {
          if (this.isMobile) {
            Dialog.alert({
              title: "提示",
              message: `文件大小超过${this.fileSize}${this.sizeUnit}！`,
            }).then(() => {
              this.clearFile(files);
              return false;
            });
          } else {
            this.$alert(
              `文件大小超过${this.fileSize}${this.sizeUnit}！`,
              "提示",
              {
                confirmButtonText: "确定",
                callback: () => {
                  this.clearFile(files);
                },
              }
            );
          }
          return false;
        }
      }

      if (this.isMobile) {
        this.loading = this.$loading({
          text: "正在上传...",
          background: "rgba(255, 255, 255, 0.8)",
          lock: true,
        });
      } else this.panelShow = true;
      files.forEach((item) => {
        this.do_preCheck(item);
      });
    },
    clearFile(files) {
      files.forEach((file) => {
        file.cancel();
      });
    },
    onFileProgress(rootFile, file, chunk) {
      // eslint-disable-next-line no-console
      console.log(
        `上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${
          chunk.endByte / 1024 / 1024
        }`
      );
    },
    fileStatusText(status, response) {
      const statusTextMap = {
        uploading: "上传中...",
        paused: "等待中...",
        waiting: "等待中...",
      };
      if (status === "success") {
        return response.message;
      } else if (status === "error") {
        return "上传失败:" + response.message;
      } else {
        return statusTextMap[status];
      }
    },
    async onFileSuccess(rootFile, file, response) {
      let that = this;
      let res = JSON.parse(response);
      // 服务器自定义的错误（即虽返回200，但是是错误的情况），这种错误是Uploader无法拦截的
      if (
        res.code === 2006 ||
        res.code === 2004 ||
        res.code === 500 ||
        res.code === -1
      ) {
        file.error = true;
        that.fileStatusText("error", res);
        if (that.isMobile) {
          Toast.fail(res.message);
        } else {
          that.$notify.error({
            title: "错误",
            message: res.message,
          });
        }
        return;
      }
      const postData = {
        filename: file.name,
        identifier: file.uniqueIdentifier,
        relativePath: file.relativePath,
        totalSize: file.size,
      };
      const { code, data } = await mergeUpload(postData);
      if (code && code === 1 && data) {
        data.path =
          location.protocol +
          "//" +
          location.host +
          `${baseURL}/dms/file/stream?id=${
            data.id
          }&type=0&time=${new Date().getTime()}`;
        this.fileList.push(data);
        this.$emit("input", this.fileList);
        this.$emit("success");
        this.close();
      } else {
        file.error = true;
        that.fileStatusText("error", { message: data || "请求失败" });
        if (this.isMobile) this.loading.close();
        this.$emit("error");
        return false;
      }
    },

    // 一个根文件（文件夹）已完成。
    fileComplete() {
      // if (this.uploader.getSize() === this.uploader.sizeUploaded()) {
      // }
    },
    onFileError(rootFile, file, response) {
      this.fileStatusText("error", response);
      if (this.isMobile) this.loading.close();
      if (this.isMobile) {
        Toast.fail(response.message);
      } else {
        this.$notify.error({
          title: "错误",
          message: response.message,
        });
      }
    },
    async do_preCheck(files) {
      let suffix = "";
      let arr = files.name.split(".");
      if (arr.length >= 1) {
        suffix = "." + arr[arr.length - 1];
      }
      const postData = {
        size: files.size, // 文件体积，单位byte
        suffix: suffix, // 文档后缀(带点)
        relativePath: files.relativePath, // 文件夹上传的时候文件的相对路径属性（包括最后一个文件及其后缀）
      };
      const { code } = await checkUpload(postData);
      if (code && code === 1) {
        this.index += 1;
        this.computeMD5(files);
      } else {
        files.cancel();
        if (this.isMobile) this.loading.close();
      }
    },
    /**
     * 计算md5，实现断点续传及秒传
     * @param file
     */
    computeMD5(file) {
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();
      // file.cmd5 = true
      file.pause();

      loadNext();

      fileReader.onload = (e) => {
        spark.append(e.target.result);

        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();

          // 实时展示MD5的计算进度
          // this.$nextTick(() => {
          //   $(`.myStatus_${file.id}`).text(
          //     "校验MD5 " + ((currentChunk / chunks) * 100).toFixed(0) + "%"
          //   );
          // });
        } else {
          let md5 = spark.end();
          // spark.destroy()
          this.computeMD5Success(md5, file);

          // eslint-disable-next-line no-console
          console.log(
            `MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${
              file.size
            } 用时：${new Date().getTime() - time} ms`
          );
        }
      };

      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;

        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },

    computeMD5Success(md5, file) {
      // 将自定义参数直接加载uploader实例的opts上
      // Object.assign(this.uploader.opts, {
      //   query: {
      //     ...this.params,
      //   },
      // })
      file.uniqueIdentifier = md5;
      // file.cmd5 = false
      file.resume();
    },
    close() {
      if (this.isMobile) this.loading.close();
      else this.panelShow = false;
    },
    closeCache() {
      this.uploader.cancel();
      this.index = 0;
      this.panelShow = false;
    },
    error(msg) {
      if (this.isMobile) {
        this.loading.close();
        Toast.fail({
          message: msg,
          duration: 2000,
        });
      } else {
        this.$notify.error({
          title: "错误",
          message: msg,
          duration: 2000,
        });
      }
    },

    // 点击下载文件
    async handleClick(file) {
      if (!file.id) return;
      const postData = {
        list: [file.id],
        name: file.name,
      };
      await downloadPartialFile(postData, decodeURI(file.name));
    },
    // 删除已经上传成功的文件
    handleRemove(file, index) {
      this.fileList.splice(index, 1);
      this.$emit("input", this.fileList);
      // this.$confirm(`确定移除${file.name}？`, '提示').then(() => {
      // }).catch(() => { })
    },
  },
};
</script>

<style scoped lang="scss">
#global-uploader {
  position: fixed;
  z-index: 9999;
  right: 8px;
  bottom: 8px;
  -webkit-box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  background: #ffffff;
  border-radius: 4px;

  .uploader-app {
    width: 700px;
  }

  #uploadDrop {
    display: none;
    position: fixed;
    z-index: 99999;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    border: 10px dashed #ccc;
    color: #aaa;
    font-size: 60px;
    text-align: center;
  }

  .file-panel {
    background-color: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 7px 7px 0 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

    .file-title {
      display: flex;
      height: 40px;
      line-height: 40px;
      padding: 0 15px;
      border-bottom: 1px solid #ddd;

      .title {
        font-size: 20px;
        font-weight: 600;
      }

      .middle {
        .hide-success-box {
          margin-left: 20px;
        }
      }

      .operate {
        flex: 1;
        text-align: right;

        .warning-about-empty-folder {
          background: yellow;
          color: red;
          font-size: 14px;
          padding: 5px 10px 5px 6px;
          margin-right: 20px;
        }
      }
    }

    .file-list {
      position: relative;
      height: 350px;
      overflow-x: hidden;
      overflow-y: auto;
      background-color: #fff;
      padding: 5px 5px 5px 5px;
      margin: 0;

      ::v-deep {
        .uploader-file-status {
          text-align: center;
          text-indent: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .no-file {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
  }

  ::v-deep {
    .uploader-file-icon {
    }
  }

  ::v-deep {
    .uploader-file-actions > span {
      margin-right: 6px;
    }
  }
}

/* 隐藏上传按钮 */
#rock-uploader-partial-btn {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}

#rock-uploader-partial-folder-btn {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}

.mobile-is-success {
  .el-icon-upload-danger {
    color: $base-color-danger;
  }

  &:hover {
    background-color: transparent;

    .el-upload-list__item-status-label {
      display: block;
    }
  }
}
</style>
